// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.form-container {
  margin: 0 auto;
  display: flex;
  justify-content: center;
  position: relative;
  z-index: 1;
  display: flex;
  flex-direction: column;    
  margin-bottom: 11.99vh;
}

.container {
  min-height: 390px;
  border-radius: 5px;
  border: 1px solid #ccc;
  background: white;
  display: flex;
  flex-direction: column;
  margin: 21px auto;
  position: relative;
  width: 100%;
  max-width: 1230px;
}

.language-selector button {
  margin-right: 10px;
}

.register-button {
  background-color: #ab2f40;
  margin-left: 23px;
  border: none;
  padding: 10px 20px;
  cursor: pointer;
  height: 100%;
  margin-right: 24px;
}

h2 {
  text-align: center;
  margin-bottom: 20px;
}

.form-steps {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 22px 15%;
  margin-bottom: 0px;
  border-bottom: 1px solid #e1e9ef;
}

.step-number {
  border-radius: 50%;
  height: 36px;
  width: 36px;
  min-width: 36px;
  margin-right: 10px;
  text-align: center;
  line-height: 34px;
  border: 2px solid #20a5de;
}

.step-number.active {
  background-color: #113559;
  color: white;
}

.form-container-button {
  display: flex;
  padding: 12px 200px 18px;
  justify-content: end;
  margin-bottom: 0px;
  border-top: 1px solid #e1e9ef;
  height: 51px;
}

.step-label {
  line-height: 38px;
  font-size: 14px;
  font-weight: bold;
}

.step-label.active {
  font-weight: bold;
  font-size: 14px;
}

.form-group {
  min-width: 254px;
}

.img-background,
.backgrounbd-container { 
  width: 100%;
  position: absolute;
  top: 0;
}

.login-title {
  max-width: 55%;
  margin: auto;
  color: white;
  font-weight: 800;
  font-size: 50px;
  top: 46px;
  left: 403px;
  margin-top: 90px;
  margin-bottom: 25px;
}

img.img-truck {
  position: absolute;
  z-index: 2;
  top: 71px;
  left: -1px;
  width: 379px;
}

.step-container {
  min-width: 11.75rem;
  display: flex;
  align-items: center;
}

.line-container {
  flex-grow: 1;
  display: flex;
  justify-content: right;
  position: relative;
}

.line {
  height: 2px;
  width: 100%;
  background: #20a5de;
  margin-left: 15%; /* Ajusta este valor según el espacio deseado */
}

.postcode {
  display: flex;
  flex-direction: row;
  width: 100%;
  justify-content: space-between;
  margin-bottom: 34px;
}

.postcode .container-input-message:first-child {
  width: 60%;
}

.postcode .container-input-message:not(:first-child) {
  width: 100%;
}

.custom-input-container.from {
  width: 100%;
}

.from-and-to-container {
  padding: 52px 15%;
}

.backgroundMid {
  display: none;
}

.cancel {
  font-family: Nunito;
  font-size: 16px;
  font-weight: 800;
  line-height: 22px;
  color: #4793ef;
  height: 40px;
  width: 148px;
  display: flex;
  justify-content: center;
  align-items: center;
  margin-right: 11px;
}

button.primary.undefined.disable {
  background-color: #ab2f4099;
}

.error-message-container {
  width: 100%;
  height: 299px;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
}

.error-message-container .error-message {
  position: unset;
  height: fit-content;
  margin-bottom: 34px;
}

.error-message-container img {
  margin-bottom: 18px;
}
.backgroundNoPeople{
  display: none;
}
@media (max-width: 1307px) {
  .container {
    width: 94%;
    margin-right: 0px;
    margin-left: 32px;
    margin-top: 23px;
  }
  .from-and-to-container {
    padding: 47px 5% !important;
  }
  /* .shipment-form {
    padding: 0px !important;
    margin: auto;
    max-width: 836px;
  }
  p.description-shipment {
    max-width: 811px;
    text-align: justify;
  } */
  img.img-truck {
    position: absolute;
    z-index: 2;
    top: 73px;
    left: -49px;
    width: 355px;
  }
  /* .line {
    width: 24%;
    right: 287px;
  } */

  .form-steps {
    padding: 22px 106px 22px 129px;
  }

  /* .custom-input-container.postCode {
    width: 36%;
  } */

  .form-container-button {
    margin: auto;
    padding: 12px 7%;
  }
  h2.login-title {
    font-size: 40px;
    margin-top: 96px;
    margin-bottom: 26px;
  }
  .logo-container {
    margin-left: 28px;
    margin-top: 7px;
  }
  button.login-button {
    margin-right: 23px;
  }
  button.register-button {
    margin-right: 27px;
  }
  .img-background {
    display: none;
  }
  .backgroundMid {
    display: block;
  }
  
}

@media (max-width: 920px) {
  .postcode {
    display: flex;
    flex-direction: column;
    width: 100%;
    justify-content: space-between;
    margin-bottom: 16px;
    gap: 16px;
  }

  .from-and-to-container {
    display: flex;
    flex-direction: column;
    padding: 40px 5% !important;
  }

  .postcode .container-input-message:first-child {
    width: 100%;
  }

  .custom-input-container.postCode {
    width: 100%;
  }

  .custom-input-container.from {
    width: 100%;
  }

  img.img-truck {
    display: none;
  }

  .login-title {
    margin-left: 0px !important;
  }

  .form-steps {
    padding: 1.5rem 5%;
  }

  .container {
    width: 90%;
    margin: 0px auto;
  }

  .form-container-button {
    padding: 12px 10px;
  }

  .login-title {
    margin: 5% auto !important;
  }
  .line {
    margin-left: 5%;
  }
}

@media (max-width: 520px) {
  .login-title {
    font-size: 26px !important;
    margin: 24px 0px;
  }

  .container {
    width: 100%;
    margin: 0px;
  }
  .step-container{
    min-width: 7rem;
  }
  .line {
    margin-left: 2%;
  }
  .form-steps{
    padding: 1rem 1rem;
  }
  
  .backgroundMid {
    display: none;
  }

  .backgroundNoPeople {
    display: block !important;
  }
  .login-title {
    margin: 8% auto !important;
  }

  .img-background, .backgrounbd-container{
    background-color: #252630 !important;
  }
  
}
`, "",{"version":3,"sources":["webpack://./src/components/FormContainer/styles.css"],"names":[],"mappings":"AAAA;EACE,cAAc;EACd,aAAa;EACb,uBAAuB;EACvB,kBAAkB;EAClB,UAAU;EACV,aAAa;EACb,sBAAsB;EACtB,sBAAsB;AACxB;;AAEA;EACE,iBAAiB;EACjB,kBAAkB;EAClB,sBAAsB;EACtB,iBAAiB;EACjB,aAAa;EACb,sBAAsB;EACtB,iBAAiB;EACjB,kBAAkB;EAClB,WAAW;EACX,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,yBAAyB;EACzB,iBAAiB;EACjB,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,YAAY;EACZ,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,iBAAiB;EACjB,kBAAkB;EAClB,gCAAgC;AAClC;;AAEA;EACE,kBAAkB;EAClB,YAAY;EACZ,WAAW;EACX,eAAe;EACf,kBAAkB;EAClB,kBAAkB;EAClB,iBAAiB;EACjB,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,YAAY;AACd;;AAEA;EACE,aAAa;EACb,wBAAwB;EACxB,oBAAoB;EACpB,kBAAkB;EAClB,6BAA6B;EAC7B,YAAY;AACd;;AAEA;EACE,iBAAiB;EACjB,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,iBAAiB;EACjB,eAAe;AACjB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;;EAEE,WAAW;EACX,kBAAkB;EAClB,MAAM;AACR;;AAEA;EACE,cAAc;EACd,YAAY;EACZ,YAAY;EACZ,gBAAgB;EAChB,eAAe;EACf,SAAS;EACT,WAAW;EACX,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,SAAS;EACT,UAAU;EACV,YAAY;AACd;;AAEA;EACE,mBAAmB;EACnB,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,sBAAsB;EACtB,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,WAAW;EACX,mBAAmB;EACnB,gBAAgB,EAAE,+CAA+C;AACnE;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,8BAA8B;EAC9B,mBAAmB;AACrB;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,cAAc;EACd,YAAY;EACZ,YAAY;EACZ,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,WAAW;EACX,aAAa;EACb,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,sBAAsB;AACxB;;AAEA;EACE,eAAe;EACf,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;AACA;EACE,aAAa;AACf;AACA;EACE;IACE,UAAU;IACV,iBAAiB;IACjB,iBAAiB;IACjB,gBAAgB;EAClB;EACA;IACE,2BAA2B;EAC7B;EACA;;;;;;;;KAQG;EACH;IACE,kBAAkB;IAClB,UAAU;IACV,SAAS;IACT,WAAW;IACX,YAAY;EACd;EACA;;;KAGG;;EAEH;IACE,8BAA8B;EAChC;;EAEA;;KAEG;;EAEH;IACE,YAAY;IACZ,gBAAgB;EAClB;EACA;IACE,eAAe;IACf,gBAAgB;IAChB,mBAAmB;EACrB;EACA;IACE,iBAAiB;IACjB,eAAe;EACjB;EACA;IACE,kBAAkB;EACpB;EACA;IACE,kBAAkB;EACpB;EACA;IACE,aAAa;EACf;EACA;IACE,cAAc;EAChB;;AAEF;;AAEA;EACE;IACE,aAAa;IACb,sBAAsB;IACtB,WAAW;IACX,8BAA8B;IAC9B,mBAAmB;IACnB,SAAS;EACX;;EAEA;IACE,aAAa;IACb,sBAAsB;IACtB,2BAA2B;EAC7B;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,2BAA2B;EAC7B;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,UAAU;IACV,gBAAgB;EAClB;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,0BAA0B;EAC5B;EACA;IACE,eAAe;EACjB;AACF;;AAEA;EACE;IACE,0BAA0B;IAC1B,gBAAgB;EAClB;;EAEA;IACE,WAAW;IACX,WAAW;EACb;EACA;IACE,eAAe;EACjB;EACA;IACE,eAAe;EACjB;EACA;IACE,kBAAkB;EACpB;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,yBAAyB;EAC3B;EACA;IACE,0BAA0B;EAC5B;;EAEA;IACE,oCAAoC;EACtC;;AAEF","sourcesContent":[".form-container {\n  margin: 0 auto;\n  display: flex;\n  justify-content: center;\n  position: relative;\n  z-index: 1;\n  display: flex;\n  flex-direction: column;    \n  margin-bottom: 11.99vh;\n}\n\n.container {\n  min-height: 390px;\n  border-radius: 5px;\n  border: 1px solid #ccc;\n  background: white;\n  display: flex;\n  flex-direction: column;\n  margin: 21px auto;\n  position: relative;\n  width: 100%;\n  max-width: 1230px;\n}\n\n.language-selector button {\n  margin-right: 10px;\n}\n\n.register-button {\n  background-color: #ab2f40;\n  margin-left: 23px;\n  border: none;\n  padding: 10px 20px;\n  cursor: pointer;\n  height: 100%;\n  margin-right: 24px;\n}\n\nh2 {\n  text-align: center;\n  margin-bottom: 20px;\n}\n\n.form-steps {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  padding: 22px 15%;\n  margin-bottom: 0px;\n  border-bottom: 1px solid #e1e9ef;\n}\n\n.step-number {\n  border-radius: 50%;\n  height: 36px;\n  width: 36px;\n  min-width: 36px;\n  margin-right: 10px;\n  text-align: center;\n  line-height: 34px;\n  border: 2px solid #20a5de;\n}\n\n.step-number.active {\n  background-color: #113559;\n  color: white;\n}\n\n.form-container-button {\n  display: flex;\n  padding: 12px 200px 18px;\n  justify-content: end;\n  margin-bottom: 0px;\n  border-top: 1px solid #e1e9ef;\n  height: 51px;\n}\n\n.step-label {\n  line-height: 38px;\n  font-size: 14px;\n  font-weight: bold;\n}\n\n.step-label.active {\n  font-weight: bold;\n  font-size: 14px;\n}\n\n.form-group {\n  min-width: 254px;\n}\n\n.img-background,\n.backgrounbd-container { \n  width: 100%;\n  position: absolute;\n  top: 0;\n}\n\n.login-title {\n  max-width: 55%;\n  margin: auto;\n  color: white;\n  font-weight: 800;\n  font-size: 50px;\n  top: 46px;\n  left: 403px;\n  margin-top: 90px;\n  margin-bottom: 25px;\n}\n\nimg.img-truck {\n  position: absolute;\n  z-index: 2;\n  top: 71px;\n  left: -1px;\n  width: 379px;\n}\n\n.step-container {\n  min-width: 11.75rem;\n  display: flex;\n  align-items: center;\n}\n\n.line-container {\n  flex-grow: 1;\n  display: flex;\n  justify-content: right;\n  position: relative;\n}\n\n.line {\n  height: 2px;\n  width: 100%;\n  background: #20a5de;\n  margin-left: 15%; /* Ajusta este valor según el espacio deseado */\n}\n\n.postcode {\n  display: flex;\n  flex-direction: row;\n  width: 100%;\n  justify-content: space-between;\n  margin-bottom: 34px;\n}\n\n.postcode .container-input-message:first-child {\n  width: 60%;\n}\n\n.postcode .container-input-message:not(:first-child) {\n  width: 100%;\n}\n\n.custom-input-container.from {\n  width: 100%;\n}\n\n.from-and-to-container {\n  padding: 52px 15%;\n}\n\n.backgroundMid {\n  display: none;\n}\n\n.cancel {\n  font-family: Nunito;\n  font-size: 16px;\n  font-weight: 800;\n  line-height: 22px;\n  color: #4793ef;\n  height: 40px;\n  width: 148px;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  margin-right: 11px;\n}\n\nbutton.primary.undefined.disable {\n  background-color: #ab2f4099;\n}\n\n.error-message-container {\n  width: 100%;\n  height: 299px;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  flex-direction: column;\n}\n\n.error-message-container .error-message {\n  position: unset;\n  height: fit-content;\n  margin-bottom: 34px;\n}\n\n.error-message-container img {\n  margin-bottom: 18px;\n}\n.backgroundNoPeople{\n  display: none;\n}\n@media (max-width: 1307px) {\n  .container {\n    width: 94%;\n    margin-right: 0px;\n    margin-left: 32px;\n    margin-top: 23px;\n  }\n  .from-and-to-container {\n    padding: 47px 5% !important;\n  }\n  /* .shipment-form {\n    padding: 0px !important;\n    margin: auto;\n    max-width: 836px;\n  }\n  p.description-shipment {\n    max-width: 811px;\n    text-align: justify;\n  } */\n  img.img-truck {\n    position: absolute;\n    z-index: 2;\n    top: 73px;\n    left: -49px;\n    width: 355px;\n  }\n  /* .line {\n    width: 24%;\n    right: 287px;\n  } */\n\n  .form-steps {\n    padding: 22px 106px 22px 129px;\n  }\n\n  /* .custom-input-container.postCode {\n    width: 36%;\n  } */\n\n  .form-container-button {\n    margin: auto;\n    padding: 12px 7%;\n  }\n  h2.login-title {\n    font-size: 40px;\n    margin-top: 96px;\n    margin-bottom: 26px;\n  }\n  .logo-container {\n    margin-left: 28px;\n    margin-top: 7px;\n  }\n  button.login-button {\n    margin-right: 23px;\n  }\n  button.register-button {\n    margin-right: 27px;\n  }\n  .img-background {\n    display: none;\n  }\n  .backgroundMid {\n    display: block;\n  }\n  \n}\n\n@media (max-width: 920px) {\n  .postcode {\n    display: flex;\n    flex-direction: column;\n    width: 100%;\n    justify-content: space-between;\n    margin-bottom: 16px;\n    gap: 16px;\n  }\n\n  .from-and-to-container {\n    display: flex;\n    flex-direction: column;\n    padding: 40px 5% !important;\n  }\n\n  .postcode .container-input-message:first-child {\n    width: 100%;\n  }\n\n  .custom-input-container.postCode {\n    width: 100%;\n  }\n\n  .custom-input-container.from {\n    width: 100%;\n  }\n\n  img.img-truck {\n    display: none;\n  }\n\n  .login-title {\n    margin-left: 0px !important;\n  }\n\n  .form-steps {\n    padding: 1.5rem 5%;\n  }\n\n  .container {\n    width: 90%;\n    margin: 0px auto;\n  }\n\n  .form-container-button {\n    padding: 12px 10px;\n  }\n\n  .login-title {\n    margin: 5% auto !important;\n  }\n  .line {\n    margin-left: 5%;\n  }\n}\n\n@media (max-width: 520px) {\n  .login-title {\n    font-size: 26px !important;\n    margin: 24px 0px;\n  }\n\n  .container {\n    width: 100%;\n    margin: 0px;\n  }\n  .step-container{\n    min-width: 7rem;\n  }\n  .line {\n    margin-left: 2%;\n  }\n  .form-steps{\n    padding: 1rem 1rem;\n  }\n  \n  .backgroundMid {\n    display: none;\n  }\n\n  .backgroundNoPeople {\n    display: block !important;\n  }\n  .login-title {\n    margin: 8% auto !important;\n  }\n\n  .img-background, .backgrounbd-container{\n    background-color: #252630 !important;\n  }\n  \n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
